var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseAcknowledgedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9843 9.71545C7.59906 9.71545 9.71861 7.59646 9.71861 4.98273C9.71861 2.36899 7.59906 0.25 4.9843 0.25C2.36955 0.25 0.25 2.36899 0.25 4.98273C0.25 7.59646 2.36955 9.71545 4.9843 9.71545Z",
    fill: "white",
    stroke: "#14BF86",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98409 4.98587C9.98202 4.33153 9.85106 3.68401 9.59867 3.08027C9.34627 2.47653 8.9774 1.9284 8.51311 1.46717C8.04882 1.00594 7.4982 0.64065 6.89269 0.392153C6.28717 0.143656 5.63863 0.0168178 4.98409 0.0188817L4.99981 5.00158L9.98409 4.98587Z",
    fill: "#14BF86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseAcknowledgedGreen);
export default __webpack_public_path__ + "static/media/ellipse-acknowledged-green.82732e1c97fc7829bf443db5d68ae97a.svg";
export { ForwardRef as ReactComponent };